export default "__VITE_ASSET__0002835f__"